var React = require('react');

function IconPreapproved (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20Zm0-6.674h0L14.017,16l-1.379-4.534L16.5,8.572H11.631L10,4,8.369,8.572,3.5,8.583l3.862,2.882L5.983,16,10,13.327Z","key":1})]);
}

IconPreapproved.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = IconPreapproved;

IconPreapproved.default = IconPreapproved;
